<template>
    <v-row justify="end">
      <v-col cols="6" md="3">
        <v-btn
          block
          depressed
          color="primary"
          :disabled="!isFormValid"
          @click="save"
        >
          {{ this.acceptLabel ? this.acceptLabel : 'save' }}
        </v-btn>
      </v-col>
      <v-col cols="6" md="3" class="pl-2">
        <v-btn
          block
          outlined
          depressed
          @click="cancel"
        >
          {{ this.cancelLabel ? this.cancelLabel : 'cancel' }}
        </v-btn>
      </v-col>
    </v-row>
</template>

<script>
export default {
  props: [
    'isFormValid',
    'acceptLabel',
    'cancelLabel'
  ],
  methods: {
    save () {
      this.$emit('save')
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
